import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import parse from "html-react-parser";
import React, { FC } from "react";

import {
    isItemsInspectionPickupSelectionLocked,
    itemsInspectionPickupLockedMessage,
} from "@store/Framework/Common/Utilities/itemsInspection";
import { useCurrentCart } from "@store/Framework/Store/Data/Carts/CartsHooks";
import InfosBoxComponent, {
    infosBoxTypeOptions,
    InfosBoxType,
} from "@store/Library/Components/Toolkit/InfosBox";
import { getDataOptionsFieldDefinition } from "@store/Framework/Common/Utilities/dataOptions";

const enum fields {
    message = "message",
    type = "type",
}

interface Props extends WidgetProps {
    fields: {
        [fields.message]: string;
        [fields.type]: InfosBoxType;
    };
}

const CartPickupLockedMessage: FC<Props> = ({ fields: { message, type } }) => {
    const cart = useCurrentCart();
    if (!isItemsInspectionPickupSelectionLocked(cart)) {
        return null;
    }

    const content = message ? parse(message, parserOptions) : translate(itemsInspectionPickupLockedMessage);

    return (
        <InfosBoxComponent type={type || "warning"} data-test-selector="cartPickupLockedMessage">
            {content}
        </InfosBoxComponent>
    );
};

const widgetModule: WidgetModule = {
    component: CartPickupLockedMessage,
    definition: {
        displayName: "Pickup Locked Message",
        group: "Cart",
        icon: "truck",
        allowedContexts: ["CartPage"],
        fieldDefinitions: [
            {
                ...getDataOptionsFieldDefinition(infosBoxTypeOptions),
                name: fields.type,
                displayName: "Type",
                fieldType: "Contextual",
                hideEmptyOption: true,
                defaultValue: "warning",
            },
            {
                name: fields.message,
                displayName: "Message",
                defaultValue: "",
                editorTemplate: "RichTextField",
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;
